import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

import NavBar_v03Responsive from '../../component-library/NavBar_v03a_Responsive_component';

import AccordianList from '../../component-library/Accordian_List_v01-component';
import ItemList from '../../component-library/ItemList_v01';
import ItemListImage from '../../component-library/ItemList-Image_v01';
import BizServicesListImagesMultiColumn_v03 from '../../component-library/BizServicesListImagesMultiColumn_v03';
import businessInsuranceData from '../../Insurance-Legacy/insurance-data-documents/InsuranceData-Business_v03a-Images-stock.json';
import personalInsuranceData from '../../Insurance-Legacy/insurance-data-documents/InsuranceData-Personal_v03-Images-stock.json';

import { IAppConfig } from "../../App_v01_Interfaces";


interface AppConfigProps{
  appConfig: IAppConfig;
}


const TestPage_v01:  React.FC<AppConfigProps> = ({appConfig}) => {
  return (
    <>
    {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

    <section className="py-5 bg-light">
      <Container>
        <Row className="mb-4">
          <Col md={6}>
            <h2>About Sundance Vending</h2>

            <div className="masked-text">Shiny Masked Text</div>

            <h1 className="flash-shadow">SunDance Vending</h1>

            <br></br>
            <div className="shadow-box">BOX SunDance Vending</div>

            <br></br>
            
            <div className="masked-underline">Masked Bottom Border</div>

            <br></br>
            <p>
              We offer modern, high-quality vending solutions tailored for today’s
              workplaces, schools, gyms, and public spaces. Our services range from drink and snack machines to
              micro markets, premium coffee and customized healthy food solutions.
            </p>
            <p>
              With cutting-edge inventory tracking, 24/7 machine uptime, and a customer-first approach, we make
              vending effortless for organizations and delightful for users.
            </p>
          </Col>
          <Col md={6}>
            {/* <Image
              src="/images/sundance-dancer-logo.png" // replace with actual logo/image path
              alt="Sundance Vending Company Logo"
              fluid
              className="rounded"
            /> */}
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <h5>Advanced Vending Solutions</h5>
            <ul>
              <li>Smart vending tech with remote monitoring</li>
              <li>Customized product selections</li>
              <li>Cashless & contactless payments</li>
              <li>Energy-efficient, modern machines</li>
            </ul>
          </Col>

          <Col md={4}>
            <h5>Our Services</h5>
            <ul>
              <li>Drink & Snack Machines</li>
              <li>Combo Machines</li>
              <li>Micro Markets</li>
              <li>Custom Branding</li>
            </ul>
          </Col>

          <Col md={4}>
            <h5>Service Areas</h5>
            <ul>
              <li>Corporate Offices</li>
              <li>Schools & Universities</li>
              <li>Fitness Centers</li>
              <li>Industrial & Public Facilities</li>
              <li>Warehouse & Manufacturing</li>
              <li>Medical & veterinary </li>

 

            </ul>
          </Col>
        </Row>
      </Container>
    </section>


    {/* <br></br>
    <hr></hr>
    <br></br>
    <h2>Accordian List - Insurance Compoent</h2>
    <AccordianList></AccordianList>
   
   
   
    <br></br>
    <hr></hr>
    <br></br>
    <h2>Standard List - Insurance List Compoent</h2>
    <ItemList></ItemList>
    

   
    <br></br>
    <hr></hr>
    <br></br>
    <h2>Standard <Image></Image> List - Insurance List Compoent</h2>
    <ItemListImage></ItemListImage> */}
    
 
    <br></br>
    <hr></hr>
    <br></br>
    <h2>Standard Image - Multi COL Multi-Image List - Insurance List Compoent</h2>
    {/* <BizServicesListImagesMultiColumn_v03 bizServicesData={businessInsuranceData} ></BizServicesListImagesMultiColumn_v03> */}
    
    <br></br>
    <hr></hr>
    <br></br>
    <h2>Standard Image - Multi COL Multi-Image List - Insurance List Compoent</h2>
    {/* <BizServicesListImagesMultiColumn_v03 bizServicesData={personalInsuranceData} ></BizServicesListImagesMultiColumn_v03> */}
    </>

  );
};

export default TestPage_v01;



// const About_v01:  React.FC<AppConfigProps> = ({appConfig}) => {
//   return (
//     <>
//       {/* <Navbar_v01 appConfig={appConfig}/> */}

//       <NavBar_v03LeftRight appConfig={appConfig} />
//       <div className='container mt-5'>
//         <h2>About_v01</h2>
//         <p>Welcome to the About_v01 page of Cost Crusher Insurance.</p>
//       </div>
//     </>
//   );
// };

// export default About_v01;
